import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	header: {
		id: 'servicedesk-request-type-security.config-button.config-modal.request-type-permissions-config.empty-state.header',
		defaultMessage: 'Unable to restrict who can raise requests via email',
		description: 'Header for request type permissions empty state when email request type is used.',
	},
	description: {
		id: 'servicedesk-request-type-security.config-button.config-modal.request-type-permissions-config.empty-state.description',
		defaultMessage:
			'Any request types used by email channel can’t be restricted in order for anonymous users to still send requests via email.',
		description:
			'Description for request type permissions empty state when email request type is used.',
	},
});
